import React from 'react';
import { Button } from '@components';
import { Card, Form, Row, Col, ButtonGroup } from 'react-bootstrap';
import { Formik } from 'formik';
import * as yup from 'yup';
import { useLocation, useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Get, Put } from '@app/utils/httpProvider';
import { useQuery, useQueryClient, useMutation } from 'react-query';
import 'react-tabs/style/react-tabs.css';
import {
    messageError,
    messageToast,
    status200,
} from '../../utils/define';
import {
    ASSETGROUP_API,
} from '../../utils/apiUrl.js';
import HorizontalFieldsRow from '@app/components/common/HorizontalFieldsRow';
import Editor from '@app/components/editor/Editor';

const schema = yup.object().shape({
    assetGroupCode: yup.string().required(messageError.emptyMessage),
    assetGroupName: yup.string().required(messageError.emptyMessage),
    description: yup.string().nullable(),
});

const AssetGroupEdit = () => {
    const history = useHistory();
    const queryClient = useQueryClient();
    const location = useLocation();
    const paramUrl = new URLSearchParams(location.search.substring(1));
    const itemId = paramUrl.get('id');

    // const inforAccount = getInfomationAccountFromToken();
    // let accountRoleManageDevice = false;

    // if (inforAccount && inforAccount.role) {
    //     const userRole = inforAccount.role.split(', ');
    //     accountRoleManageDevice =
    //         userRole.includes(role.Admin) || userRole.includes(role.Editor);
    //     // accountRoleBooker =
    //     //     userRole.includes(role.Admin) || userRole.includes(role.Booker);
    // }

    const itemEdit = useQuery([itemId], () =>
        Get(ASSETGROUP_API.GET_ITEM, itemId)
    );

    const editFunc = useMutation((value) =>
        Put(ASSETGROUP_API.UPDATE_ITEM, itemId, value)
    );

    const handleEdit = async (values) => {
        const model = { ...values };

        model.id = itemId;

        editFunc.mutate(model, {
            onSuccess: (res) => {
                if (res.status !== status200) {
                    toast.error(messageToast.messageToastUpdateError);
                } else {
                    toast.success(messageToast.messageToastUpdateSuccess);
                    // dispatch(
                    //     apiRoleMappingPagingAction({
                    //         PageIndex: 1,
                    //         PageSize: 10000
                    //     })
                    // );
                    queryClient.setQueryData(itemId, model);
                    history.goBack();
                }
            },
            onError: (res) => {
                toast.error(
                    res.message || 'Đã có lỗi xảy ra, vui lòng thử lại !'
                );
            }
        });
    };

    const isLoading = itemEdit.isLoading ? true : false;
    const isError = itemEdit.isError ? true : false;
    const error = itemEdit.isError ? itemEdit.error : null;

    return (
        <Card>
            <Card.Header as="h5">Xem hoặc sửa nhóm tài sản</Card.Header>
            <Card.Body>
                {isLoading ? (
                    <div>Đang tải...</div>
                ) : isError ? (
                    <div>Có lỗi xảy ra: ${error.message}</div>
                ) : itemEdit.data == null ? (
                    <div>Danh mục không tồn tại</div>
                ) : (
                    <Formik
                        enableReinitialize
                        validationSchema={schema}
                        onSubmit={(values) => handleEdit(values)}
                        initialValues={{
                            assetGroupCode:
                                itemEdit.data && itemEdit.data.assetGroupCode
                                    ? itemEdit.data.assetGroupCode
                                    : '',
                            assetGroupName:
                                itemEdit.data && itemEdit.data.assetGroupName
                                    ? itemEdit.data.assetGroupName
                                    : '',
                            description:
                                itemEdit.data && itemEdit.data.description
                                    ? itemEdit.data.description
                                    : '',
                        }}
                    >
                        {({
                            handleSubmit,
                            handleChange,
                            values,
                            errors,
                            touched,
                            setFieldValue
                        }) => (
                            <Form noValidate onSubmit={handleSubmit}>
                                <HorizontalFieldsRow
                                    fields={[
                                        {
                                            label: 'Mã nhóm',
                                            name: 'assetGroupCode',
                                            value: values.assetGroupCode,
                                            onChange: handleChange,
                                            isInvalid: errors.assetGroupCode && touched.assetGroupCode,
                                            error: touched.assetGroupCode ? errors.assetGroupCode : null
                                        },
                                        {
                                            label: 'Tên nhóm',
                                            name: 'assetGroupName',
                                            value: values.assetGroupName,
                                            onChange: handleChange,
                                            isInvalid: errors.assetGroupName && touched.assetGroupName,
                                            error: touched.assetGroupName ? errors.assetGroupName : null
                                        }
                                    ]}
                                />
                                <Form.Group as={Row} className="mb-3">
                                    <Form.Label className="col-sm-2 col-form-label">
                                        Mô tả
                                    </Form.Label>
                                    <Col sm="10">
                                        <Editor
                                            name="description"
                                            value={values.description}
                                            onChange={(value) => {
                                                setFieldValue(
                                                    'description',
                                                    value
                                                );
                                            }}
                                        />
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-3">
                                    <Col md={{ span: 10, offset: 2 }}>
                                        <ButtonGroup className="mb-2">
                                            <Button
                                                type="submit"
                                                theme="primary"
                                            >
                                                Sửa
                                            </Button>
                                            &nbsp;&nbsp;&nbsp;
                                            <Button
                                                onClick={() => history.goBack()}
                                                theme="secondary"
                                            >
                                                Hủy
                                            </Button>
                                        </ButtonGroup>
                                    </Col>
                                </Form.Group>
                            </Form>
                        )}
                    </Formik>
                )}
            </Card.Body>
        </Card>
    );
};

export default AssetGroupEdit;
